<p
  *ngIf="!!component.config.headerHelperText"
  class="header-helper-text iris-mb-02"
>
  {{component.config.headerHelperText}}
</p>
<h2
  *ngIf="!!component.config.heroText"
  class="hero-text-header"
  [ngClass]="{'no-bottom-margin': !component.config.helpText}"
  data-test="hero-header-text"
>
  <!-- TODO: Remove in in MER-2127 -->
  <ng-container *ngIf="(overrideReasonDetail$ | async)">
    Do you have any preferences for a therapist you want to share?
  </ng-container>
  <ng-container *ngIf="!(overrideReasonDetail$ | async)">
    {{ component.config.heroText | bindTemplate: response.data }}
  </ng-container>
</h2>
<p
  *ngIf="showOptionalTextSlugs.has(component.slug)"
  class="hero-text-optional"
  data-test="hero-header-text-optional"
>
  (optional)
</p>
